import { Cell } from "src/types"

export const COLUMNS = 10
export const ROWS = 18
export const CELL_SIZE = 45
export const PADDING = 2
export const WIDTH = COLUMNS * (CELL_SIZE + PADDING) - PADDING
export const HEIGHT = ROWS * (CELL_SIZE + PADDING) - PADDING
export const SCORES_PER_LINES = [0, 40, 100, 300, 1200]
export const SPEED_PER_LEVEL = [
  48, 43, 38, 33, 28, 23, 18, 13,  8,  6,
   5,  5,  5,  4,  4,  4,  3,  3,  3,  2,
   2,  2,  2,  2,  2,  2,  2,  2,  2,  1
]

export enum CELL {
  EMPTY = " ",
      O = "o",
      S = "s",
      Z = "z",
      I = "i",
      J = "j",
      T = "t",
      L = "l"
}

export const CELL_COLORS = {
  " ": "#434c5e",
  "o": "#bf616a",
  "s": "#d08770",
  "z": "#ebcb8b",
  "i": "#a3be8c",
  "j": "#b48ead",
  "t": "#5e81ac",
  "l": "#8fbcbb"
}

export enum ACTION {
  MOVE_BLOCK_DOWN = "MOVE_BLOCK_DOWN",
  MOVE_BLOCK_LEFT = "MOVE_BLOCK_LEFT",
  MOVE_BLOCK_RIGHT = "MOVE_BLOCK_RIGHT",
  ROTATE_BLOCK_LEFT = "ROTATE_BLOCK_LEFT",
  ROTATE_BLOCK_RIGHT = "ROTATE_BLOCK_RIGHT",
  STOP_AUTO_DROP = "STOP_AUTO_DROP",
  START_AUTO_DROP = "START_AUTO_DROP"
}

const o: Cell[][][] = [[
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.O    , CELL.O    , CELL.EMPTY],
  [CELL.EMPTY, CELL.O    , CELL.O    , CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
]]

const s: Cell[][][] = [[
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.S    , CELL.S    , CELL.EMPTY],
  [CELL.S    , CELL.S    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.S    , CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.S    , CELL.S    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.S    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
]]

const z: Cell[][][] = [[
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.Z    , CELL.Z    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.Z    , CELL.Z    , CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.Z    , CELL.EMPTY, CELL.EMPTY],
  [CELL.Z    , CELL.Z    , CELL.EMPTY, CELL.EMPTY],
  [CELL.Z    , CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
]]

const i: Cell[][][] = [[
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.I    , CELL.I    , CELL.I    , CELL.I    ],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.I    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.I    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.I    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.I    , CELL.EMPTY, CELL.EMPTY]
]]

const j: Cell[][][] = [[
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.J    , CELL.J    , CELL.J    , CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.J    , CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.J    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.J    , CELL.EMPTY, CELL.EMPTY],
  [CELL.J    , CELL.J    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.J    , CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.J    , CELL.J    , CELL.J    , CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.J, CELL.J, CELL.EMPTY],
  [CELL.EMPTY, CELL.J, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.J, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
]]

const t: Cell[][][] = [[
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.T    , CELL.T    , CELL.T    , CELL.EMPTY],
  [CELL.EMPTY, CELL.T    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.T    , CELL.EMPTY, CELL.EMPTY],
  [CELL.T    , CELL.T    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.T    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.T    , CELL.EMPTY, CELL.EMPTY],
  [CELL.T    , CELL.T    , CELL.T    , CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.T    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.T    , CELL.T    , CELL.EMPTY],
  [CELL.EMPTY, CELL.T    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]

]]

const l: Cell[][][] = [[
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.L    , CELL.L    , CELL.L    , CELL.EMPTY],
  [CELL.L    , CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.L    , CELL.L    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.L    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.L    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.EMPTY, CELL.L    , CELL.EMPTY],
  [CELL.L    , CELL.L    , CELL.L    , CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]
],
[
  [CELL.EMPTY, CELL.L    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.L    , CELL.EMPTY, CELL.EMPTY],
  [CELL.EMPTY, CELL.L    , CELL.L    , CELL.EMPTY],
  [CELL.EMPTY, CELL.EMPTY, CELL.EMPTY, CELL.EMPTY]

]]
 
export const BLOCKS: Record<string, Cell[][][]> = {
  "o": o,
  "s": s,
  "z": z,
  "i": i,
  "j": j,
  "t": t,
  "l": l
}
